export interface TypiValue {
  size: number
  lineHeight: number
}

export interface TypiSize {
  default: TypiValue
  tablet?: TypiValue
  desktop?: TypiValue
}

interface TypiConfig {
  [size: string]: TypiSize
}

export const typi: TypiConfig = {
  xsmall: {
    default: { size: 11, lineHeight: 16 },
  },
  small: {
    default: { size: 14.222, lineHeight: 20 },
  },
  base: {
    default: { size: 16, lineHeight: 24 },
  },
  large: {
    default: { size: 20.25, lineHeight: 28 },
  },
  xlarge: {
    default: { size: 28.833, lineHeight: 36 },
  },
  h5: {
    default: { size: 20.25, lineHeight: 28 },
  },
  h4: {
    default: { size: 20.25, lineHeight: 28 },
    tablet: { size: 25.629, lineHeight: 32 },
  },
  h3: {
    default: { size: 25.629, lineHeight: 32 },
    tablet: { size: 28.833, lineHeight: 36 },
  },
  h2: {
    default: { size: 28.833, lineHeight: 36 },
    tablet: { size: 32.437, lineHeight: 40 },
    desktop: { size: 36.491, lineHeight: 40 },
  },
  h1: {
    // default: { size: 46.184, lineHeight: 64 },
    tablet: { size: 58.452, lineHeight: 72 },
    // COVID
    // desktop: { size: 73.978, lineHeight: 96 },
    default: { size: 32.437, lineHeight: 40 },
    desktop: { size: 58.452, lineHeight: 72 },
  },
}

export const fontFamily = {
  roboto: "'Roboto Slab', serif",
  merienda: "'Merienda One', cursive",
}

export type FontFamily = keyof typeof fontFamily

export const fontWeight = {
  light: 300,
  normal: 400,
  // medium: 500,
  // semiBold: 600,
  bold: 700,
}

export type FontWeight = keyof typeof fontWeight
